<div class="horizontal-container center-children">
    <div class="horizontal-container fill right-buffer">
        <status-icon [rpa]="item" [clickable]="false"></status-icon>
        <action-required *ngIf="showTypeRequired">
            <p>
                This RPA requires the custom
                <em>
                    {{ showTypeRequired.make }}
                    {{ showTypeRequired.model }}
                </em>
                RPA type to also be shared. Failing to do so may cause errors in
                the child organisation.
            </p>
        </action-required>
    </div>
    <div class="fill vertical-container">
        <div class="wrap-overflow">
            {{ item.rpaType?.make }} {{ item.rpaType?.model }}
        </div>
        <div class="wrap-overflow">SN: {{ item.manufacturerSerialNumber }}</div>
        <div *ngIf="showOwner" class="wrap-overflow">
            Owner:
            {{ item.organisation.name }}
        </div>
        <div *ngIf="showCustodian" class="wrap-overflow">
            Custodian:
            {{ item.custodian | formatOrganisation | defaultTo: 'Owner' }}
        </div>
    </div>
</div>
